import * as dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import history from 'lib/history';

import TestSessionCard from './TestSessionCard';

const TestSessionCardContainer = ({ testSession, testSessions, ...props }) => {
  const { t } = useTranslation();
  const isOngoing = useMemo(
    () => dayjs().isBetween(testSession.startTime, testSession.stopTime),
    [testSession],
  );
  const handleTestResultView = useCallback(() => {
    history.push({
      pathname: `/test-review/${testSession.courseId}`,
      state: {
        accountId: testSession.accountId,
        accountIds: testSessions.map((session) => session.accountId),
      },
    });
  }, [testSession, testSessions]);
  return (
    <TestSessionCard
      handleTestResultView={handleTestResultView}
      isOngoing={isOngoing}
      t={t}
      testSession={testSession}
      {...props}
    />
  );
};

TestSessionCardContainer.propTypes = {
  testSession: PropTypes.object.isRequired,
  testSessions: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default TestSessionCardContainer;
